import type { ThemeOptions } from '@mui/material/styles';
import { fonts } from './tokens';

// Sizes follow the prototype: page title 21/800, section titles 18/800, panel titles 15/700.
const head = { fontFamily: fonts.head };

export const typography: ThemeOptions['typography'] = {
  fontFamily: fonts.body,
  fontSize: 14,
  h1: {
    ...head,
    fontWeight: 800,
    fontSize: '1.3125rem',
    lineHeight: 1.06,
    letterSpacing: '-0.02em',
  },
  h2: { ...head, fontWeight: 800, fontSize: '1.25rem', lineHeight: 1.2, letterSpacing: '-0.015em' },
  h3: {
    ...head,
    fontWeight: 800,
    fontSize: '1.125rem',
    lineHeight: 1.25,
    letterSpacing: '-0.01em',
  },
  h4: { ...head, fontWeight: 700, fontSize: '0.96875rem', lineHeight: 1.3 },
  h5: { ...head, fontWeight: 700, fontSize: '0.90625rem', lineHeight: 1.35 },
  h6: { ...head, fontWeight: 700, fontSize: '0.84375rem', lineHeight: 1.35 },
  subtitle1: { fontWeight: 700, fontSize: '0.875rem' },
  subtitle2: { fontWeight: 700, fontSize: '0.78125rem' },
  body1: { fontSize: '0.875rem', lineHeight: 1.5 },
  body2: { fontSize: '0.8125rem', lineHeight: 1.5 },
  caption: { fontSize: '0.71875rem', lineHeight: 1.4 },
  button: { fontWeight: 600, textTransform: 'none', letterSpacing: 0 },
  overline: { fontSize: '0.59375rem', letterSpacing: '0.16em', fontWeight: 800, lineHeight: 1.4 },
  // Small uppercase eyebrow above section titles ("AUFFÄLLIGKEITEN").
  kicker: {
    fontSize: '0.65625rem',
    letterSpacing: '0.13em',
    textTransform: 'uppercase',
    fontWeight: 800,
    lineHeight: 1.4,
  },
  // Large tabular figure on KPI cards.
  kpi: {
    ...head,
    fontWeight: 800,
    fontSize: '1.9375rem',
    lineHeight: 1,
    letterSpacing: '-0.025em',
    fontVariantNumeric: 'tabular-nums',
  },
  // Field/filter label above controls.
  label: { fontSize: '0.6875rem', fontWeight: 600, lineHeight: 1.4 },
};
